import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="container">
      <div className="header">
        <img className="wm-banner" src="/wm-banner.svg" alt="WM — In motion with me" />
        <h1>Activity Streaming</h1>
      </div>
      
      <div className="card" style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '2rem' }}>Get Started</h2>
        <Link to="/create">
          <button className="button button-primary">
            Create New Event
          </button>
        </Link>
      </div>
      
      <div className="card" style={{ marginTop: '2rem' }}>
        <h3>How it works:</h3>
        <ol style={{ marginLeft: '2rem', lineHeight: '2' }}>
          <li>Create a new event and get your unique hash code</li>
          <li>Pair your mobile app with the hash code</li>
          <li>Share the event URL with spectators</li>
          <li>Start your activity and stream live!</li>
        </ol>
      </div>
    </div>
  );
};

export default Home;
